import api from './api'

export interface InterviewGenerationRequest {
  resume_id: string
  job_id: string
  interview_level?: string
  focus_areas?: string[]
}

export interface InterviewQuestion {
  category: string
  question: string
  what_to_listen_for: string[]
}

export interface InterviewGuide {
  candidate_name: string
  job_title: string
  interview_level: string
  overall_score: number
  scope: {
    target_level: string
    areas_to_test: string[]
    key_technologies: string[]
    focus_areas: string[]
  }
  key_questions: InterviewQuestion[]
  optional_exercise?: {
    title: string
    description: string
    time_limit: string
    evaluation_criteria: string[]
  }
  scorecard: {
    categories: Array<{
      name: string
      weight: number
    }>
    rating_scale: string
    recommendation_threshold: string
  }
  recommendation_guidelines: string
}

export interface InterviewGenerationResponse {
  interview_id: string
  generated_at: string
  guide: InterviewGuide
  generation_time_ms: number
  cached?: boolean
  is_new_generation?: boolean
}

export interface InterviewEligibilityResponse {
  eligible: boolean
  reason: string
  overall_score: number
  skill_match_score: number
  experience_match_score: number
  cultural_fit_score: number
}

export const interviewApi = {
  // Generate interview questions
  generateInterview: async (request: InterviewGenerationRequest): Promise<InterviewGenerationResponse> => {
    const response = await api.post('/interviews/generate', request)
    return response.data
  },

  // Check if candidate is eligible for interview
  checkEligibility: async (resumeId: string, jobId: string): Promise<InterviewEligibilityResponse> => {
    const response = await api.get(`/interviews/check-eligibility/${resumeId}/${jobId}`)
    return response.data
  },

  // Reprocess interview questions (clear existing and generate new ones)
  reprocessInterview: async (request: InterviewGenerationRequest): Promise<InterviewGenerationResponse> => {
    const response = await api.post('/interviews/reprocess', request)
    return response.data
  }
}
